import {
  HOME_SIGN_IN_NAG_CLOSE_LARGE_NAG_AND_OPEN_SMALL,
  HOME_SIGN_IN_NAG_OPEN_LARGE_WITH_ANIMATION,
  HOME_SIGN_IN_NAG_SHOW_TERMS,
} from './types';

export const openLargeNagWithAnimation = () => ({
  type: HOME_SIGN_IN_NAG_OPEN_LARGE_WITH_ANIMATION,
});

export const showTerms = () => ({
  type: HOME_SIGN_IN_NAG_SHOW_TERMS,
});

export const closeLargeNagAndOpenSmall = () => ({
  type: HOME_SIGN_IN_NAG_CLOSE_LARGE_NAG_AND_OPEN_SMALL,
});
